import { render, staticRenderFns } from "./BadgeTest.vue?vue&type=template&id=5c7c66e8&scoped=true&"
import script from "./BadgeTest.vue?vue&type=script&lang=js&"
export * from "./BadgeTest.vue?vue&type=script&lang=js&"
import style0 from "./BadgeTest.vue?vue&type=style&index=0&id=5c7c66e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7c66e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCheckbox,VSelect})
